export default __webpack_public_path__ + "static/hero-background-image-46c957d41f03f6b8e642dd354211aa65.svg";